import './job.css';
import img_nextway from '../../img/nextway.png';
import img_nextway_android from '../../img/nextway-play-store-qr.png';
import img_nextway_ios from '../../img/nextway-app-store-qr.png';

export default function Nextway() {
  return (
    <div id="wrapper">
      <div className="section_title">Nextway</div>
      <div
        style={{
          padding: '20px 20px',
          color: '#55ba5e',
          backgroundColor: '#ffffff',
          width: '90%',
          padding: '10px',
          margin: '10px',
          float: 'left'
        }}
      >
        <h2 className="angebote">
          Nextway Rechnungsverarbeitung
        </h2>
        <span style={{ color: '#000000', fontSize: '14px' }}>
          <p>
          Mit unserer neuen Software <b>Nextway</b> wird die digitale
Rechnungsverarbeitung einfacher und schneller. Übermitteln Sie ab sofort
Ihre Warenwirtschaftsdaten und Eingangsrechnungen direkt über Nextway an
die Finanzbuchhaltung. Das Programm ist benutzerfreundlich gestaltet und
hilft Ihnen, die Arbeit noch effizienter zu erledigen.
          </p>

          <img
            className="nextway"
            src={img_nextway}
          />

          <br></br>
          <p style={{fontWeight: 'bold'}}>
            Eine Kurzanleitung finden Sie hier: <a
              className="underline"
              target="_blank"
              href="https://intranet-backend.procuratio.com/nc/Intranet/Uploads/Kurzanleitung/Kurzanleitung_Nextway.pdf"
            >
              Anleitung
            </a>
          </p>
          <br></br>

          <h1>Aufruf im Web</h1>
          <a
            className="underline"
            href="https://dms.procuratio.com"
            style={{fontSize: '2em'}}
            target="_blank"
          >
            dms.procuratio.com
          </a>
          <br></br>
          <br></br>
          <br></br>
          <br></br>

          <div style={{display:'none'}}>
          <h3>Next® Go App</h3>

          <h4>Apple App Store</h4>
          <a
            className="underline"
            href="https://apps.apple.com/de/app/next-go/id1534562112"
            target="_blank"
          >
            apps.apple.com/de/app/next-go/id1534562112
          </a>
          <br></br>
          <img
            className="qr"
            src={img_nextway_ios}
          />

          <h4>Google Play</h4>
          <a
            className="underline"
            href="https://play.google.com/store/apps/details?id=com.nextway.next_go"
            target="_blank"
          >
            play.google.com/store/apps/details?id=com.nextway.next_go
          </a>
          <br></br>
          <img
            className="qr"
            src={img_nextway_android}
          />
          </div>
          
          <br></br>
          <br></br>

          <br></br>

        </span>
      </div>
    </div>
  );
}
